export default "__VITE_ASSET__BYu3ctAk__"